import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { UPDATE_CHECK_LIST } from "../apiRoutes";

const mutateUpdateChecklist = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${UPDATE_CHECK_LIST}${id}`, data);
};

const useUpdateChecklistInventoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateChecklist,
    ...queryParams,
  });

export default useUpdateChecklistInventoryMutation;
